// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

export enum DefaultView {
  EXPANDED = 0,
  OVERHEAD = 1,
  STATUS = 2,
  MAP = 3,
}
